import React, { Fragment } from 'react';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';

import AlbumsIcon from '../../../../../../../../components/icons/AlbumFolderGalleryIcon';
import Button from '../../../../../../../../components/global/Button';
import ProfilePageCard from '../../../ProfilePageCard';
import { getDateLabel } from '../../../../../../../../util/album';
import UploadIcon from '../../../../../../../../components/icons/UploadIcon';

const propTypes = {
  className: PropTypes.string,
  hierarchyItem: PropTypes.shape({
    childAlbumCount: PropTypes.number,
    coverPhotoUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
    startDate: PropTypes.string,
    hasUploadPermissions: PropTypes.bool,
  }).isRequired,
  onItemClick: PropTypes.func,
  onUpload: PropTypes.func,
  primary: PropTypes.bool,
};

const HierarchyItemCard = ({
  className,
  hierarchyItem,
  onItemClick,
  onUpload,
  primary = false,
}) => {
  const {
    childAlbumCount,
    coverPhotoUrl,
    name,
    hasUploadPermissions,
  } = hierarchyItem;

  return (
    <ProfilePageCard
      onClick={onItemClick}
      className={className}
      title={name}
      thumbnailUrl={coverPhotoUrl}
      isDefaultThumbnail={!coverPhotoUrl}
      subtitle={`${getDateLabel(hierarchyItem)}`}
      note={
        childAlbumCount > 0
          ? `${childAlbumCount} ${pluralize('album', childAlbumCount)}`
          : ''
      }
      icon={primary ? <AlbumsIcon /> : null}
      thumbnailActions={
        <Fragment>
          {hasUploadPermissions && (
            <Button
              btnSize="xs"
              className="profile-page-card-button-icon"
              btnStyle="reset"
              onClick={() => onUpload(hierarchyItem)}
            >
              <UploadIcon size={22} />
            </Button>
          )}
        </Fragment>
      }
    />
  );
};

HierarchyItemCard.propTypes = propTypes;

export default HierarchyItemCard;
